import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { saveAs } from 'file-saver';
import { ParticipantApiService } from '../../api/participant-api.service';
import { DocumentModel } from '../../models/document.model';
import { DocumentService } from '../../services/document.service';
import { Helper } from '@portal/util';
import { Subject, takeUntil } from 'rxjs';

@Component({
  selector: 'portal-signing-view-document',
  templateUrl: './view-document.component.html',
  styleUrls: ['./view-document.component.scss'],
})
export class ViewDocumentComponent implements OnInit, OnDestroy {
  private readonly destroy$ = new Subject<void>();
  accessToken!: string;
  accessTokenInfo: any;
  contractPDF: any;
  document!: DocumentModel;
  loading = true;

  constructor(
    private route: ActivatedRoute,
    private participantApiService: ParticipantApiService,
    private documentService: DocumentService,
  ) {}

  ngOnInit(): void {
    this.accessToken = this.route.snapshot.queryParams['accessToken'];
    this.accessTokenInfo = Helper.decodeJWT(this.accessToken);
    this.loadContractDetail();
    this.loadContractPDF();
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  loadContractDetail() {
    this.participantApiService
      .getContractDetail(this.accessToken)
      .pipe(takeUntil(this.destroy$))
      .subscribe((res: any) => {
        this.document = res;
      });
  }

  loadContractPDF() {
    this.participantApiService
      .getContractPDF(this.accessToken)
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (res: any) => {
          this.contractPDF = res;
          this.loading = false;
        },
        error: () => {
          this.loading = false;
        },
      });
  }

  download() {
    if (this.document.contentType === 'pdfO') {
      this.participantApiService
        .postManualEdit(
          {
            name: 'download',
            description: 'The Signer downloads document',
            metadata: {
              anyOtherInfo: this.accessTokenInfo,
            },
          },
          this.accessToken,
        )
        .pipe(takeUntil(this.destroy$))
        .subscribe();
      const blob = new Blob([this.contractPDF], { type: 'application/pdf' });
      saveAs(blob, this.document.name + '.pdf');
      return;
    }
    this.participantApiService
      .getContractHtml(this.accessToken)
      .pipe(takeUntil(this.destroy$))
      .subscribe((html: any) => {
        const printOptions = {
          margin: this.document.content.printOptions.margin,
          headerTemplate: this.document.header,
          footerTemplate: this.document.footer,
          displayHeaderFooter: true,
          isHideBottomLineSignature: true,
        };
        this.documentService.download(html, this.document.name, printOptions, this.accessToken);
        this.participantApiService
          .postManualEdit(
            {
              name: 'download',
              description: 'The Signer downloads document',
              metadata: {
                anyOtherInfo: this.accessTokenInfo,
              },
            },
            this.accessToken,
          )
          .pipe(takeUntil(this.destroy$))
          .subscribe();
      });
  }
}
